import request from "root/js/request";

export const postSplitToSuppliesExportArchive = async ({
  cabinet_id,
  date,
  map,
  dates,
  alter_quantity,
  barcode_id__not_in,
  sales_share_history_period,
}) => {
  const response = await request({
    url: `analytics/wh_supply/split_to_supplies/export_archive/${date}/`,
    method: "post",
    params: {
      cabinet_id,
      sales_share_history_period,
      barcode_id__not_in,
      date,
    },
    data: {
      map,
      dates,
      alter_quantity,
    },
  });
  return response.data;
};
